import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const WaterResourcesSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.waterResources;
  const hasData = !!data && !!(
    data.waterStressAnalysis || data.waterRightsAssessment || data.groundwaterSurfaceWater ||
    data.thermalDischarge || data.stormwaterManagement
  );
  return (
    <SectionShell label={label} hasData={hasData}>
      {data?.waterStressAnalysis && <EditorialSubsection theme={theme} label="Water Stress Analysis">{data.waterStressAnalysis}</EditorialSubsection>}
      {data?.waterRightsAssessment && <EditorialSubsection theme={theme} label="Water Rights Assessment">{data.waterRightsAssessment}</EditorialSubsection>}
      {data?.groundwaterSurfaceWater && <EditorialSubsection theme={theme} label="Groundwater & Surface Water">{data.groundwaterSurfaceWater}</EditorialSubsection>}
      {data?.thermalDischarge && <EditorialSubsection theme={theme} label="Thermal Discharge (CWA 316(a))">{data.thermalDischarge}</EditorialSubsection>}
      {data?.stormwaterManagement && <EditorialSubsection theme={theme} label="Stormwater Management (NPDES/SWPPP)">{data.stormwaterManagement}</EditorialSubsection>}
    </SectionShell>
  );
};
